import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import brandlogo from "../assets/img/logo/ji-impex.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars, faSearch, faPhoneAlt,
  faEnvelopeOpen, faClock
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebookF, faWhatsapp, faLinkedinIn, faInstagram
} from "@fortawesome/free-brands-svg-icons";

const Navbar = ({ searchTerm, setSearchTerm }) => {
  const location = useLocation();
  const navigate = useNavigate();
  
  const [categories, setCategories] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);
  const [isSticky, setIsSticky] = useState(false);
  const [openCategory, setOpenCategory] = useState(null);
  const [openSubcategory, setOpenSubcategory] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [showSearch, setShowSearch] = useState(false);

  // Handle Search Functionality
  const handleSearch = (e) => {
    e.preventDefault();
    if (searchTerm.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchTerm)}`);
      setShowSearch(false); 
    }
  };

  // Fetch Categories and Manage Event Listeners
  useEffect(() => {
    fetch("https://jiimpex.com/new_project/ji-impex/get-categories.php")
      .then((response) => response.json())
      .then((data) => setCategories(data))
      .catch((error) => console.error("Error fetching categories:", error));

    const handleResize = () => setIsMobile(window.innerWidth <= 991);
    const handleScroll = () => setIsSticky(window.scrollY > 100);

    window.addEventListener("resize", handleResize);
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const closeMobileMenu = () => {
    if (isMobile) {
      setMobileMenuOpen(false);
      setOpenCategory(null);
      setOpenSubcategory(null);
    }
  };

  return (
    <>

      {/* Top Contact Section */}
      <div className="container-fluid bg-light p-0">
        <div className="row gx-0 d-none d-lg-flex">
          <div className="col-lg-7 px-5 text-start position-relative">
            <div className="h-100 d-inline-flex align-items-center border-start border-end px-3">
              <FontAwesomeIcon icon={faPhoneAlt} className="me-2" />
              <small>
                <a href="tel:+919316819979" style={{ color: "#8D9297" }}>
                  +91 931 681 9979
                </a>
              </small>
            </div>
            <div className="h-100 d-inline-flex align-items-center border-end px-3">
              <FontAwesomeIcon icon={faEnvelopeOpen} className="me-2" />
              <small>
                <a
                  href="mailto:sales@jiimpex.com"
                  style={{ color: "#8D9297" }}
                >
                 sales@jiimpex.com
                </a>
              </small>
            </div>
            <div className="h-100 d-inline-flex align-items-center border-end px-3">
              <FontAwesomeIcon icon={faClock} className="me-2" />
              <small>Mon - Fri : 09 AM - 09 PM</small>
            </div>
            {/* Search Icon and Field */}
            <div className="h-100 d-inline-flex align-items-center px-3">
              {showSearch && (
                <div className="search-overlay" onClick={() => setShowSearch(false)}/>
              )}
              {!showSearch && (
                <FontAwesomeIcon
                  icon={faSearch}
                  className="search-icon"
                  onClick={() => setShowSearch(!showSearch)}
                />
              )}
              <div className={`h-auto align-items-unset search-input-container ${showSearch ? "show" : ""}`}>
                {showSearch && (
                  <form class="search-form" onSubmit={handleSearch}>
                    <input
                      type="text"
                      placeholder="Search Products..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <button type="submit">Search</button>
                  </form>
                )}
              </div>
            </div>
          </div>
          {/* Social Media Icons */}
          <div className="col-lg-5 px-5 text-end">
            <div className="h-100 d-inline-flex align-items-center">
              <a
                className="btn btn-square border-end border-start"
                href="https://www.facebook.com/share/15rm2uCHio/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faFacebookF} />
              </a>
              <a
                className="btn btn-square border-end"
                href="https://wa.me/+919316819979?text=Hello,%20I%20am%20intrested%20in%20your%20products"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faWhatsapp} />
              </a>
              <a
                className="btn btn-square border-end"
                href="https://www.linkedin.com/in/abdullah-hamidani-358a24351?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faLinkedinIn} />
              </a>
              <a
                className="btn btn-square border-end"
                href="https://www.instagram.com/j.i.impex?utm_source=qr&igsh=dGpydXZpN2RvMHZz"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faInstagram} />
              </a>
            </div>
          </div>
        </div>
      </div>
      <nav
        className={`navbar navbar-expand-lg bg-white navbar-light sticky-top ${isSticky ? "sticky-navbar" : ""
          }`}
      >
        <div className="container-fluid">
          <Link to="/" className="navbar-brand">
            <img
              src={brandlogo}
              alt="Ji Impex"
              className="img-fluid company-logo"
            />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <FontAwesomeIcon icon={faBars} />
          </button>
          <div
            className={`collapse navbar-collapse ${mobileMenuOpen ? "show" : ""
              }`}
          >
            <ul className="navbar-nav m-auto">
              <li className="nav-item">
                <Link
                  className={`nav-link ${location.pathname === "/" ? "active" : ""
                    }`}
                  to="/"
                  onClick={closeMobileMenu}
                >
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className={`nav-link ${location.pathname === "/about" ? "active" : ""
                    }`}
                  to="/about"
                  onClick={closeMobileMenu}
                >
                  About Us
                </Link>
              </li>

              {categories.map((category) => (
                <li
                  key={category.id}
                  className="nav-item dropdown position-relative"
                  onMouseEnter={
                    !isMobile ? () => setOpenCategory(category.id) : null
                  }
                  onMouseLeave={!isMobile ? () => setOpenCategory(null) : null}
                >
                  <span
                    className={`nav-link dropdown-toggle ${openCategory === category.id ? "active" : ""
                      }`}
                    onClick={
                      isMobile
                        ? () =>
                          setOpenCategory(
                            openCategory === category.id ? null : category.id
                          )
                        : null
                    }
                  >
                    {category.name}
                  </span>
                  {/* {openCategory === category.id && ( */}
                  <div
                    className={`dropdown-menu ${isMobile ? "d-block" : "position-absolute"
                      }`}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      minWidth: "700px",
                      backgroundColor: 'transparent',
                      right: '-50%',
                      justifyContent: 'center',
                    }}
                  >
                    {/* Left Side: Main Categories */}
                    <div
                      style={{

                        borderRight: "1px solid #ddd",
                        paddingRight: "10px",
                        maxHeight: "400px",
                        overflowY: "auto",
                        background: '#fff',
                        padding: '10px',

                      }}
                    >
                      {category.subcategories.map((sub) => (
                        <div
                          key={sub.id}
                          className="dropdown-item d-flex justify-content-between align-items-center"
                          onMouseEnter={() => setOpenSubcategory(sub.id)}
                          onMouseLeave={() => setOpenSubcategory(sub.id)}
                        >
                           <Link
                              key={sub.id}
                              to={`/products/${sub.id}`}
                              className="dropdown-item"
                              onClick={closeMobileMenu}
                            >
                              {sub.name}
                              {sub.subcategories.length > 0 && (
                                <span className="ms-auto">▸</span>
                              )}
                            </Link>
                        </div>
                      ))}
                    </div>

                    {/* Right Side: Only Show the Child Menu if a Subcategory is Hovered */}
                    {openSubcategory &&
                      category.subcategories.find(sub => sub.id === openSubcategory)?.subcategories.length > 0 && (<div
                        className="dropdown-menu1 bg-light"
                        style={{

                          paddingLeft: "10px",
                          maxHeight: "400px",
                          overflowY: "auto",
                          display: "block",
                          minWidth: '450px',
                        }}
                        onMouseEnter={() => {
                          console.log("hyhty", category.subcategories.length);
                          setOpenSubcategory(openSubcategory)
                        }
                        }
                        onMouseLeave={() =>
                          setOpenSubcategory(openSubcategory)
                        }
                      >
                        {category.subcategories
                          .find((sub) => sub.id === openSubcategory)
                          ?.subcategories.map((child) => (
                            <Link
                              key={child.id}
                              to={`/products/${child.id}`}
                              className="dropdown-item"
                              onClick={closeMobileMenu}
                            >
                              {child.name}
                            </Link>
                          ))}
                      </div>
                      )}
                  </div>
                  {/*  )}*/}
                </li>
              ))}

              <li className="nav-item">
                <Link
                  className={`nav-link ${location.pathname === "/contact" ? "active" : ""
                    }`}
                  to="/contact"
                  onClick={closeMobileMenu}
                >
                  Contact Us
                </Link>
              </li>
            </ul>
            
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
